import React from 'react';
import { Link } from 'react-router-dom';
import { useNotifications } from '../../context/NotificationContext';
import { getFirstUnreadTaskNotificationLink } from '../../utils/notificationMeta';
import CountBadge from './CountBadge';

const DashboardAlerts = () => {
    const { unreadCount, menuBadges, notifications } = useNotifications();
    const taskLink = getFirstUnreadTaskNotificationLink(notifications);

    const hasTasks = menuBadges.tasks > 0;
    const hasDisputes = menuBadges.disputes > 0;
    const hasUnread = unreadCount > 0;

    if (!hasTasks && !hasDisputes && !hasUnread) return null;

    return (
        <div className="rounded-2xl border border-teal-200/80 bg-gradient-to-r from-teal-50/90 via-white to-zinc-50 p-4 shadow-sm dark:border-teal-900/40 dark:from-teal-950/30 dark:via-zinc-950/40 dark:to-zinc-950/60">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-start gap-3">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal-100 text-teal-800 dark:bg-teal-900/50 dark:text-teal-300">
                        <i className="fa-solid fa-bell text-sm" />
                    </span>
                    <div>
                        <p className="text-sm font-bold text-zinc-900 dark:text-white">
                            {hasUnread
                                ? `${unreadCount} new notification${unreadCount === 1 ? '' : 's'}`
                                : 'Items need your attention'}
                        </p>
                        <p className="mt-0.5 text-xs text-zinc-600 dark:text-zinc-400">
                            {[
                                hasTasks &&
                                    `${menuBadges.tasks} task${menuBadges.tasks === 1 ? '' : 's'}`,
                                hasDisputes &&
                                    `${menuBadges.disputes} dispute${menuBadges.disputes === 1 ? '' : 's'}`,
                            ]
                                .filter(Boolean)
                                .join(' · ') || 'Review updates in your workspace'}
                        </p>
                    </div>
                </div>
                <div className="flex flex-wrap gap-2">
                    {hasTasks ? (
                        <Link
                            to={taskLink}
                            className="inline-flex items-center gap-2 rounded-lg border border-teal-200 bg-white px-3 py-2 text-xs font-semibold text-teal-900 transition-colors hover:bg-teal-50 dark:border-teal-800 dark:bg-zinc-900 dark:text-teal-200 dark:hover:bg-teal-950/40"
                        >
                            Open task
                            <CountBadge
                                value={menuBadges.tasks}
                                tone="teal"
                                className="!ml-0 !h-4 !min-w-[16px] !px-1 !text-[9px]"
                            />
                        </Link>
                    ) : null}
                    {hasDisputes ? (
                        <Link
                            to="/dispute"
                            className="inline-flex items-center gap-2 rounded-lg border border-rose-200 bg-white px-3 py-2 text-xs font-semibold text-rose-900 transition-colors hover:bg-rose-50 dark:border-rose-900/50 dark:bg-zinc-900 dark:text-rose-200 dark:hover:bg-rose-950/40"
                        >
                            View disputes
                            <CountBadge
                                value={menuBadges.disputes}
                                tone="rose"
                                className="!ml-0 !h-4 !min-w-[16px] !px-1 !text-[9px]"
                            />
                        </Link>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default DashboardAlerts;
